import { ComponentProps } from '@stitches/react'
import { Link } from 'common/Link'
import { AppRoutes } from 'config/routes'
import { Account, FeedType } from 'graphql/types'
import { theme } from 'lib/theme'
import { useRouter } from 'next/router'
import { Heading } from 'primitives/Heading'
import { List } from 'primitives/List'
import { ListItem } from 'primitives/ListItem'
import { Nav } from 'primitives/Nav'

export interface CategoriesMenuProps extends ComponentProps<typeof Nav> {
  user?: Account
}

export const CategoriesMenu: React.FC<CategoriesMenuProps> = ({ css, user }) => {
  const {
    query: { category }
  } = useRouter()

  const CATEGORY_ITEMS = [
    {
      name: 'Latest',
      value: FeedType.LATEST,
      visible: true
    },
    {
      name: 'Following',
      value: FeedType.FOLLOWING,
      visible: !!user
    },
    {
      name: 'Liked posts',
      value: FeedType.LIKED,
      visible: !!user
    }
  ]

  return (
    <Nav
      css={{
        backgroundColor: theme.colors.gray300,
        overflowX: 'auto',
        padding: '0px 16px',
        '&::-webkit-scrollbar': {
          height: 0
        },
        '@lg': {
          padding: '0px',
          backgroundColor: 'transparent'
        },
        ...css
      }}
    >
      <Heading
        as="h6"
        css={{
          lineHeight: '16px',
          marginBottom: '18px',
          display: 'none',
          '@lg': {
            display: 'block'
          }
        }}
      >
        Feeds
      </Heading>
      <List
        css={{
          display: 'flex',
          '@sm': {
            justifyContent: 'center'
          },
          '& li button': {
            whiteSpace: 'nowrap'
          },
          '& li:first-child': {
            marginRight: '4px'
          },
          '& li:not(:first-child)': {
            // margin: '0 4px',
          },
          '@lg': {
            display: 'block',
            '& li:not(:last-child)': {
              marginBottom: '12px'
            }
          }
        }}
      >
        {CATEGORY_ITEMS.filter((x) => x.visible).map(({ name, value }, i) => {
          return (
            <ListItem key={name}>
              <Link
                pill
                active={category === value?.toLowerCase()}
                href={`${AppRoutes.FEED}/${value.toLowerCase()}`}
                css={{ margin: 0, padding: '4px 10px', textAlign: 'left' }}
              >
                {name}
              </Link>
            </ListItem>
          )
        })}
        {/* <ListItem>
          <Button pill>Edit Feed</Button>
        </ListItem> */}
      </List>
    </Nav>
  )
}
